export class Roles {
    static readonly developer: string = 'ROLE_DEVELOPER';
    static readonly switchUser: string = 'ROLE_SWITCH_USER';
    static readonly siteAdmin: string = 'ROLE_SITE_ADMIN';
    static readonly appAdmin: string = 'ROLE_APP_ADMIN';
    static readonly permitAll: string = 'PERMIT_ALL';
    static readonly instructor: string = 'ROLE_INSTRUCTOR';
    static readonly departmentAdministrator: string = 'ROLE_DEPARTMENT_ADMINISTRATOR';
    static readonly registrarStaff: string = 'ROLE_REGISTRAR_STAFF';
    static readonly registrarAdmin: string = 'ROLE_REGISTRAR_ADMIN';
}
